<template>
  <div class="flex flex-col gap-y-8">
    <h3 class="text-3xl font-bold leading-6 text-color-1">
      {{ isEditing ? $t('IFrame | editTitle') : $t('IFrame | createTitle') }}
    </h3>

    <div class="flex flex-col gap-y-2">
      <base-input
        v-model="name"
        :label="$t('IFrame | label')"
        :placeholder="$t('IFrame | placeholder')"
      />

      <div v-if="hasSpecialCharacters" class="text-sm text-error">
        {{ $t('IFrame | nameError') }}
      </div>
    </div>

    <base-button
      :disabled="!name || hasSpecialCharacters"
      @onClick.stop="handleSubmit"
    >
      {{ isEditing ? $t('IFrame | saveChanges') : $t('IFrame | submit') }}
    </base-button>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue'

import BaseInput from '@emcd-shared/base-input'
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'
import segmentService from '@/shared/services/segment.service'
import { ANALYTICS_EVENT_TYPE } from '@/packages/auth-service/requiredUserAction/shared/utils/analytics'

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  isUpdate: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update:modelValue', 'onSubmit'])

const isEditing = ref(false)
const name = ref(props.modelValue)

// Проверка на наличие спецсимволов (разрешаем только буквы, цифры, пробелы, дефисы и подчеркивания)
const hasSpecialCharacters = computed(() => {
  if (!name.value) return false
  return /[^a-zA-Z0-9\s\-_]/.test(name.value)
})

onMounted(() => {
  isEditing.value = props.isUpdate || !!props.modelValue
})

watch(name, (val) => {
  emits('update:modelValue', val)
})

watch(
  () => props.modelValue,
  (val) => {
    name.value = val
  }
)

function handleSubmit() {
  if (!isEditing.value) {
    segmentService.trackNewEvent(ANALYTICS_EVENT_TYPE.CLICK, {
      event: ANALYTICS_EVENT_TYPE.CLICK,
      page: 'earn_on_swap',
      screen: 'swap_link_creation_form',
      button_name: 'create_and_copy_link',
    })
  }
  emits('onSubmit', true)
}
</script>
